module.exports = __webpack_public_path__ + "static/media/FRM.c199b0d7.png";